import { ProductQuestion } from "./ProductQuestion";

export interface IProductAnswer {
  id?: string;
  answer?: string;
  question?: ProductQuestion;
  created_at_text?: string;
  useful_votes?: number;
  useless_votes?: number;
  user_useful_voted?: boolean;
  user_useless_voted?: boolean;
}

export default class ProductAnswer implements IProductAnswer {
  public type = "product-answers";
  public relationshipNames = ["question"];

  public id?: string;
  public answer?: string;
  public question?: ProductQuestion;
  public created_at_text?: string;
  public useful_votes: number = 0;
  public useless_votes: number = 0;
  public user_useful_voted: boolean = false;
  public user_useless_voted: boolean = false;

  public constructor(data?: IProductAnswer) {
    if (data) {
      this.fill(data);
    }
  }

  public fill(data: IProductAnswer) {
    this.id = data.id;
    this.question = data.question
      ? new ProductQuestion(data.question)
      : undefined;
    this.answer = data.answer;
    this.created_at_text = data.created_at_text;
    this.useful_votes = data.useful_votes || 0;
    this.useless_votes = data.useless_votes || 0;
    this.user_useful_voted = !!data.user_useful_voted;
    this.user_useless_voted = !!data.user_useless_voted;
  }

  public static fromArray(items: IProductAnswer[]) {
    return items.map((item) => new ProductAnswer(item));
  }
}
